import { insertRow, handleDbError } from '../lib/db';
import { CashCount } from '../types';

enum OperationType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  LIST = 'list',
  GET = 'get',
  WRITE = 'write',
}

export const saveCashCount = async (userId: string, cashCount: Omit<CashCount, 'id' | 'createdAt'>) => {
  const path = `users/${userId}/cashCounts`;
  try {
    await insertRow('cashCounts', {
      ...cashCount,
      createdAt: new Date().toISOString(),
    });
  } catch (error) {
    handleDbError(error, OperationType.WRITE, path);
  }
};
